module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter2"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block8"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "h22"
    }
  }, [_vm._v("Kolton")]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p94"
    }
  }, [_vm._v("Fuck me. I’m in Colorado, on Aspen Mountain, gazing out at a kickass view, and I’m wound tighter than a drum. The endless mountain vistas usually calm me. Something about their size, imposing and downright impressive, puts life into perspective, the trivial day-to-day stresses no longer so heavy. It reminds me how lucky I am. To be here. To be able to barrel down a slope, nothing but the wind whistling in my ears and the scenery blurring by.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p95"
    }
  }, [_vm._v("But today can kiss my ass.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p96"
    }
  }, [_vm._v("Nico and Sawyer coaxed me into this trip with good intentions, but if I have to listen to them spouting off about my need to get out and live a little, work less, and find myself a piece of ass, shit’s going to get real. Although it’s been a while, I chased as much tail as Sawyer in the day, and I wasn’t the president of my fraternity for nothing. My list of pranks is a mile long. Even at twenty-nine, I have no problem whipping it out.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p97"
    }
  }, [_vm._v("This winner of a day started with Sawyer smacking the back of my head as he pushed past me into the condo kitchen, saying a groggy, “Morning, shithead. Can’t believe you turned down that chick last night. Another few weeks, and you’ll be revirginized.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p98"
    }
  }, [_vm._v("I chucked an empty beer can at his head. “Have you forgotten your scrawny teenage ass would still be whacking off to pictures of Leah Richardson if I hadn’t lied and told her your dick was huge?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p99"
    }
  }, [_vm._v("A few more insults were traded, enough to get me out to go skiing, a smile plastered on my face. But the day turned into a massive game of dominoes, each irritation fueling the next until they tumbled into a giant pile of frustration.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p100"
    }
  }, [_vm._v("My ski pass not working at the base of the mountain sucked. Not day-crushing sucked, but I sent the boys to ski on their own and had to wait for twenty minutes while the dude at the wicket stared lamely at his computer to deduce why my piece of plastic lost its data. Once his boss issued me a new pass, I hauled ass to my gear, itching to ski out my tensing muscles. That’s when I noticed the dent in my binding. Another hour and I was at the top of the lift with rental skis. Pack on, goggles down, boots buckled tight, I gripped my poles, ready to let my skis fly, but the sound of little-kid sobs stopped me. The boy looked about Jackson’s age, and if my kid were by himself at the top of Aspen Mountain, I’d raise hell.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p101"
    }
  }, [_vm._v("Instead of skiing out my frustration, I spent the next thirty minutes in the lodge, feeding the little dude chips and chocolate to keep his meltdown in check. When his ski school instructor turned up, I copied the fuckwit’s name down and made it clear he better not lose any more kids while teaching. The boy’s quiet “Thank you, mister” as he tugged on my hand had me missing Jackson hard.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p102"
    }
  }, [_vm._v("This is the first vacation I’ve taken without him. The longest I’ve been away from him in seven years. I’ve spent every minute wondering if he’s tripping on that shoelace he never ties. If he’s brushing his teeth. If he’s practicing his writing. Missing him also brought back thoughts of Marina and what I’ve lost. What I might never find again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p103"
    }
  }, [_vm._v("Determined to tackle the slopes and dull the pang of missing Jackson and Marina, I went back outside. Skis on "), _c('i', [_vm._v("again")]), _vm._v(", goggles down "), _c('i', [_vm._v("again")]), _vm._v(", and the snow crunched with each fast turn, finally easing the negative energy churning in my gut. Not for long. Halfway down the mogul run under the chairlift, I was resting my legs, cold air raking through my lungs, when a bra landed on my head. A fucking bra. Some girls were laughing their asses off as I fisted the black fabric and flung it into the trees, every cord in my neck ready to snap. Like I needed the reminder my dry spell could rival the Vancouver Canucks’ Stanley Cup drought. Sawyer would’ve busted a rib laughing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p104"
    }
  }, [_vm._v("Nearing my breaking point, I skied down hard—quick, aggressive turns until my thighs screamed—only to get stuck on the next chair for five minutes. When I made it to the top, I didn’t hesitate. I flew toward the nearest groomed trail and let my skis run, barreling down, holding nothing back. I let loose every little thing eating at me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p105"
    }
  }, [_vm._v("Until that chick careened into my side.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p106"
    }
  }, [_vm._v("I saw her fly from the trees just in time to avoid a head-on collision, but the tips of our skis crossed, sending her on her butt and me hurtling onto my shoulder. My hand and pole smacked into my goggles, the wind knocked clean out of my chest. The irritation festering all day built into full-blown rage; my only consolation was the fact that my weak shoulder didn’t dislocate. And "), _c('i', [_vm._v("this chick")]), _vm._v("? No apology. No remorse for causing the collision. She got up and blew past me. Not before giving me the one-finger salute. "), _c('i', [_vm._v("Bitch.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p107"
    }
  }, [_vm._v("As I stare out at the rugged mountains, trying to let go of the pile of shit heaped on my shoulders, I can’t help picturing how she raced down the hill like an Olympian. There’s something about athletic girls who can hold their own on the slopes that gets me going. I bet her legs are toned, her ass probably tight. Strip her out of that ski gear, and "), _c('i', [_vm._v("man")]), _vm._v(", could that be the thing to take the edge off my day. If she could keep her mouth from running.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p108"
    }
  }, [_vm._v("But that would mean casual sex—quick, fun. And meaningless. My gut churns like it did the last time I met a woman at a bar. The girl had mile-long legs and knew how to have fun, and it was. For a time. Until I left her apartment, went home alone, woke up alone, and spent the day with my son. Alone.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p109"
    }
  }, [_vm._v("I’m done with meaningless. I’m just not sure my dick got the memo.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p110"
    }
  }, [_vm._v("Swiveling downhill, I jump into a turn, picking up speed as I head to the base. I need a hot tub and drink stat.")]), _vm._v(" "), _c('div', {
    staticClass: "paras-rw decoration-rw",
    attrs: {
      "id": "decoration1"
    }
  }, [_c('p', {
    attrs: {
      "id": "p111"
    }
  }, [_vm._v("*  *  *")])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p112"
    }
  }, [_vm._v("I’m one beer in by the time Sawyer and Nico show up at the condo’s outdoor spa area. Sawyer juts his chin toward a couple of girls heading for the reception area. One has on a Moondog jacket, the other a Moondog hat, both items from our fall/winter clothing line. The Runaway Jacket—with its asymmetrical zipper, thick lapels, and buckles up the sides—fits the blonde perfectly, the deep purple tone even sharper than I remember.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p113"
    }
  }, [_vm._v("Sawyer wiggles his eyebrows. “Looks good, huh?” He tosses his towel and lowers himself into the hot tub, beer in hand.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p114"
    }
  }, [_vm._v("I sigh, dreading what’s coming. He may be the design guy behind our growing retail chain, but sometimes he goes too far, edgier than I think our clientele will dig. Not every woman wants to be rocker chic. “Do I have to say it now, or can it wait ’til later?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p115"
    }
  }, [_vm._v("After a long pull on his beer, he shrugs. “Now suits me fine.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p116"
    }
  }, [_vm._v("I tip my head back, the ends of my hair sinking into the water. “Sawyer, dude, you’re the man.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p117"
    }
  }, [_vm._v("“And?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p118"
    }
  }, [_vm._v("God, I hate when he’s right. “"), _c('i', [_vm._v("And")]), _vm._v("…next time I tell you no chick in her right mind will spend six hundred bucks on a jacket with a bunch of zippers and buckles all over it, I give you permission to waterboard me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p119"
    }
  }, [_vm._v("“If waterboarding’s going down, count me in.” Nico grins, his eyes narrowed with an evil glint that should intimidate me coming from this beast of a guy. Especially since the dude carries a gun to work. Luckily, I’ve seen him passed out with Jackson in his arms countless times, and my champ has peed on him. Twice.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p120"
    }
  }, [_vm._v("Just as he’s about to step into the water, Sawyer raises his palm. “Use the other tub. One step in here, and you’ll send the water flooding out.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p121"
    }
  }, [_vm._v("“Fuck you.” With a grunt, Nico walks his massive thighs in, sprawling out just to piss Sawyer off.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p122"
    }
  }, [_vm._v("Steam rises from the water, a few snowflakes starting to fall. A couple of kids are in the nearby pool jumping around, and my mind is back on Jackson, hoping he’s listening to his teacher. Hoping that snot Evan isn’t pushing him around.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p123"
    }
  }, [_vm._v("Evan, the little shit.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p124"
    }
  }, [_vm._v("Nico runs a hand over his buzzed head and reaches for his beer. “When’d you call it quits?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p125"
    }
  }, [_vm._v("I exhale and watch as the cold flakes dissolve on the warm stone around us. “Maybe an hour ago. Not feeling the slopes today.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p126"
    }
  }, [_vm._v("High-pitched giggles have Nico tipping his beer toward two girls who just arrived, probably too young for any of us to be watching as they strip down to their bikinis and walk gingerly into the tub a few feet away. “Jail bait,” I say.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p127"
    }
  }, [_vm._v("Sawyer snorts. “For fucking sure.” He swigs his beer then kicks me with his foot. “But that chick last night wasn’t, and she was all over you. What gives?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p128"
    }
  }, [_vm._v("Instead of answering him, I put my beer down, duck under the water, and push through the surface. The frosty air hits me like a shot of oxygen. Those kids are splashing each other, the nearby adult warning them to keep it down. I drag my hand down my face and shake out my hair.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p129"
    }
  }, [_vm._v("Nico’s eyes dart to the kids, then back to me. “It’s Jackson’s birthday next month, isn’t it?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p130"
    }
  }, [_vm._v("I nod—a quick jerk of my head, no other comment needed. Silence descends between us as we leave the rest unspoken. No one needs to mention Jackson turning seven means Marina died seven years ago. I don’t need the reminder. Life was taken and life was given. An even swap that nearly cut me down. If it weren’t for Jackson, I wouldn’t have made it.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p131"
    }
  }, [_vm._v("The girls giggle again as they whisper to each other and eye Nico. With his buzzed head, massive build, and the tattoos curving over his shoulders, he looks more Hell’s Angels than cop, but the dude is all heart. Not many guys would upend their lives and move in with a friend for eight months to help raise his son. I cringe, thinking what it would have been like if I had to move back home with my dad, stepmom, and the chaos my three stepbrothers inspire. The word "), _c('i', [_vm._v("loud")]), _vm._v(" comes to mind.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p132"
    }
  }, [_vm._v("Nico clears his throat. “Does your recent vow of celibacy have anything to do with that birthday?” Still no mention of Marina. No need to twist the knife in my gut.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p133"
    }
  }, [_vm._v("I squeeze my beer until my knuckles burn. “Not interested right now. Tons going on with the expansion at work, and Jackson keeps me busy. Time’s a commodity.” The bubbling water stills, a shriek and a splash from the pool piercing the quiet.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p134"
    }
  }, [_vm._v("“That’s bullshit and you know it.” Sawyer leans out of the tub to hit the dial, and the jets roar back to life. “You’re living your life for Jackson, which, don’t get me wrong, is awesome. That kid deserves the best. But you’ve gotta get out and live your life, too. Time "), _c('i', [_vm._v("is")]), _vm._v(" a commodity. You don’t get these years back. And believe it or not, that girly hair of yours won’t reel ’em in when it’s gray and thinning.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p135"
    }
  }, [_vm._v("I slap the edge of my hand against the water, spraying Sawyer’s face. “So what? Going from girl to girl and never settling down like you is the answer? That’s what you call living?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p136"
    }
  }, [_vm._v("Using his forearm, he wipes the water from his face. “First. Do that again, and I beat your ass. These pools are nasty. Second. Yeah, I’m living the life. The life "), _c('i', [_vm._v("I")]), _vm._v(" want. For "), _c('i', [_vm._v("me")]), _vm._v(". That’s all I’m suggesting. Nico here is your relationship guy. That works for him. I happen to like variety. Either way, you need to figure your shit out because one day Jackson will fly the coop. I say have fun in Aspen, let loose, for fuck’s sake, then maybe start into the dating again back home.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p137"
    }
  }, [_vm._v("What’s it been? Six months? Seven? Sure, work, Jackson, and life in general make it tough to find the time to date, but these days I can’t muster up the interest. Sawyer and I used to take advantage of our Moondog status, bagging chicks more than happy to list us as conquests. After a couple of them turned creepy stalker, we canned that routine and stopped telling girls what we do for a living. With them it was empty sex, anyway, always at their place, never at mine, keeping Jackson away from the temporary girls in my life. Then came dating. Everyone telling me they had "), _c('i', [_vm._v("the")]), _vm._v(" girl for me. The perfect match. A month here, a couple there, but no one with any staying power.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p138"
    }
  }, [_vm._v("No one is Marina. No one ever will be.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p139"
    }
  }, [_vm._v("Nico moves to use another jet, and the water sways like one of those wave pools. “He might have a point, dude.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p140"
    }
  }, [_vm._v("I cough on a swallow of beer. “Seriously? You’re siding with the guy who slept with your last girlfriend a month after you broke up?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p141"
    }
  }, [_vm._v("He cracks his thick neck. “There wasn’t much between us, so I gave him the okay. Besides, I knew what a letdown it would be after riding the Nico Train.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p142"
    }
  }, [_vm._v("Sawyer copies my move and blasts water in Nico’s face. “Asshole.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p143"
    }
  }, [_vm._v("Nico retaliates with a punch to the shoulder that has Sawyer cursing, then Nico turns to me. “We’re in Aspen, hot chicks everywhere. You should’ve seen the two we met on the slopes today. Might as well use the time to get back in the game. Have some fun. Then maybe hit the dating scene with more enthusiasm. Even online or something.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p144"
    }
  }, [_vm._v("I sigh. “Right. Online dating. Like that works. And if you met girls, why are you here?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p145"
    }
  }, [_vm._v("Nico shrugs. “They took off too fast. Something about meeting a friend at the bottom. And don’t diss online dating. I’ve done it. It might not have lasted, but you never know.” He points a finger at both of us. “One smartass word from either of you, and I aim for the throat.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p146"
    }
  }, [_vm._v("Sawyer and I take one look at each other and burst out laughing, beer almost spurting from my nose. “What did your profile say?” I ask. “Searching for Amazonian woman to handle massive dick?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p147"
    }
  }, [_vm._v("A slow smile lights Nico’s face. “If the shoe fits.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p148"
    }
  }, [_vm._v("Chuckling, I push up to sit on the edge of the tub, needing a break from the heat. The boys sink lower, shoulders shaking with laughter. The snow is falling harder, hopefully dumping inches on top. A powder day tomorrow would make up for today’s fail. Still, I can’t stop reliving every aggravating detail. The bra. The careless instructor. That chick with the attitude, and her effortless turns as she blew past me on the slopes. Picturing her again has heat pooling south, my dick nudging me to get some play. Maybe the boys are right. If I stop worrying about meeting the right girl, if I relax and have some fun, maybe I could approach the whole dating thing with a bit more optimism when home. Not measure every girl against Marina.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p149"
    }
  }, [_vm._v("“Fine. Let’s do it,” I say. “But not tonight. Tonight, it’s steaks and beers in. The way my day went, going out could be painful. We’ll hit the bars tomorrow. Cool?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p150"
    }
  }, [_vm._v("Nico grunts, and Sawyer says, “Works for me.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p151"
    }
  }, [_vm._v("I jump up. “I’ll head to town for food. You still off asparagus, Nico?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p152"
    }
  }, [_vm._v("He gawks at me. “That was what? A year ago?” When Sawyer makes his what-the-fuck face, Nico says to him, “You remember Stacey, the blonde I dated? She cooked the shit out of it nightly. Fucking baby food. And Bill Gates here”—he nods to me—“filed that nugget away in his mutant brain.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p153"
    }
  }, [_vm._v("“I don’t remember you complaining about my "), _c('i', [_vm._v("genius")]), _vm._v(" brain when I’d do your math homework. I’ll just get some salad stuff.” I grab my towel, looking forward to a low-key night and a better day tomorrow. Checking out the nightlife and getting laid are starting to sound good. Damn good. Between my assistant, Stella, and Marina’s mother, Jackson’s in safe hands. Work won’t implode over the next four days, and the past months of no action are catching up with me. If this trip is about living it up and letting loose, I may as well push the boundaries. For four days. Starting tomorrow. This particular day can still kiss my ass.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-738716fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s004-Chapter-002.vue
// module id = 69
// module chunks = 0